<section class="body-section Partner-request">
    <div class="container">
        <p-toast key="toastmsg"></p-toast>
        <main>
            <div class="bottom-container">
                <div class="box transaction-box">
                    <!-- <div class="header-container">
                        <h3 class="section-header">My Contest
                        </h3>
                    </div> -->
                    <div class="col-md-12 body-header">
                        <div class="media-right buttons-div-section">
                            <div class="enter-button d-flex align-items-center"
                                style="gap:10px;">
                                <div class="sub-headings d-flex filter-div p-col-12">
                                    <h4 class="c-headline__title">
                                        <span class="apt-heading">MY CONTEST</span>
                                    </h4>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="header-container">
                        <h3 class="section-header">My Contest</h3>
                    </div> -->
                            <div class="card date-filter-div">
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-2">
                                        <label for="startdt">Start Date</label>
                                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                            [(ngModel)]="fstartDate" class="p-calendar" inputId="calendar"
                                            dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                                    </div>
                                    <div class="p-field p-col-2">
                                        <label for="enddt">End Date</label>
                                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                            [(ngModel)]="fendDate" class="p-calendar" inputId="calendar"
                                            dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                                    </div>
                                    <div class="p-field p-col" style="padding-top: 30px;">
                                        <div class="button-div">
                                            <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-2"
                                                (click)="loadContest($event,mode)"></button>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-2" style="padding-top: 30px;">
                                        <div class="clear-button-div">
                                            <button pButton label="Clear Filters"
                                                class="p-button-outlined p-mr-0 p-mb-0" icon="pi pi-filter-slash"
                                                pTooltip="Clear Filters" tooltipPosition="bottom"
                                                (click)="clear()"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-content" id="pills-tabContent">
                                <div class="mobile-filter">
                                    <div class="col-md-12 right-section-top-bar px-4">
                                        <div data-bs-toggle="modal" data-bs-target="#mobile-filter-popup"
                                            class="mobile-fliter-icon"><i class="bx bx-filter-alt"></i> Filters </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                    aria-labelledby="pills-home-tab">
                                    <p-table id="vdtnetable10" #dt [value]="contestList" [paginator]="true" [rows]="10"
                                         [lazy]="true" scrollHeight="auto"
                                        scrollDirection="horizontal" [totalRecords]="totalRecords" [loading]="loading"
                                        [scrollable]="true" cellpadding="0" class="transaction-history"
                                        (onLazyLoad)="loadContest($event,mode)" aria-describedby="vdtnetable10_info">
                                        <ng-template pTemplate="header">
                                            <tr class="my-contest-heading">
                                                <th class=" name-td-partner rin-dt-align-left sorting_disabled rin-dt-ellpsis-overflow-1"
                                                    rowspan="1" colspan="1">
                                                    <div class="my-contest-head-text">Date
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div class="my-contest-head-text">Tournament Name
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div class="my-contest-head-text">Contest Match
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled current-request-location-td" rowspan="1"
                                                    colspan="1">
                                                    <div class="my-contest-head-text">Entry Fee
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div class="my-contest-head-text">Points
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div class="my-contest-head-text">Won
                                                    </div>
                                                </th>
                                                <th class="sorting_disabled" rowspan="1" colspan="1">
                                                    <div class="my-contest-head-text">Prize Pool
                                                    </div>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th class="filter-input" [ngSwitch]="matchDate">
                                                    <p-calendar appendTo="body" #pCalendarId 
                                                        inputId="calendar" dateFormat="dd/mm/yy"
                                                        placeholder="DD/MM/YYYY" style="width: 170px;"
                                                        (onSelect)="setDownloadFlag(); dt.filter($event,'matchDate', 'dateIs')"
                                                        [showIcon]="true" [(ngModel)]="dcalvalue"
                                                        ></p-calendar>
                                                </th>
                                                <th class="filter-input" [ngSwitch]="tournamentName"> 
                                                    <input pInputText type="text"
                                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentName', 'contains')"
                                                        [value]="dt.filters['tournamentName'] ? dt.filters['tournamentName'].value : ''"
                                                        />
                                                </th>
                                                <th class="filter-input" [ngSwitch]="playerName">
                                                    <input pInputText type="text"
                                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'playerName', 'contains')"
                                                        [value]="dt.filters['playerName'] ? dt.filters['playerName'].value : ''"
                                                         />
                                                </th>
                                                <th class="filter-input" [ngSwitch]="entryFee">
                                                    <input pInputText type="text"
                                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'entryFee', 'contains')"
                                                        [value]="dt.filters['entryFee'] ? dt.filters['entryFee'].value : ''"
                                                         />
                                                </th>
                                                <th class="filter-input" [ngSwitch]="totalPoints">
                                                    <input pInputText type="text"
                                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'totalPoints', 'contains')"
                                                        [value]="dt.filters['totalPoints'] ? dt.filters['totalPoints'].value : ''"
                                                         />
                                                </th>
                                                <th class="filter-input" [ngSwitch]="prizeWon">
                                                    <input pInputText type="text"
                                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'prizeWon', 'contains')"
                                                        [value]="dt.filters['prizeWon'] ? dt.filters['prizeWon'].value : ''"
                                                         />
                                                </th>
                                                <th class="filter-input" [ngSwitch]="poolPrize">
                                                    <input pInputText type="text"
                                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'poolPrize', 'contains')"
                                                        [value]="dt.filters['poolPrize'] ? dt.filters['poolPrize'].value : ''"
                                                         />
                                                </th>
                                            </tr>
                                        </ng-template>

                                        <ng-template pTemplate="body" let-contest let-columns="columns">
          
                                            <tr>
                                                <td
                                                    class="name-td-partner rin-dt-ellpsis-overflow-1 rin-dt-align-left">
                                                    <div class="data">
                                                        {{contest.matchDate | date: 'dd/MM/yyyy'}}
                                                    </div>
                                                    <br> <!---->
                                                </td>
                                                <td class="rating-td-partner">
                                                        <span
                                                        class="rin-type-label state-finished">
                                                        {{contest.tournamentName}}
                                                    </span></td>
                                                <td>
                                                    <span class="rin-type-label state-finished" style="text-decoration: underline;">
                                                        <a style="cursor: pointer;">
                                                            <span (click)="onClickMatchStats(contest.matchId)">
                                                                {{contest.player1Name}}
                                                                Vs
                                                                {{contest.player2Name}}
                                                            </span>
                                                        </a>
                                                    </span>
                                                </td>
                                                <td class="current-request-location-td">
                                                    {{contest.entryFee}}
                                                </td>
                                                <td class="current-request-location-td">
                                                    {{contest.totalPoints}}
                                                </td>
                                                <td>
                                                    <span class="rin-type-label state-finished">
                                                        <span
                                                        *ngIf="contest.totalCashPrizeWon != null || contest.totalCashPrizeWon != undefined">
                                                        {{contest.totalCashPrizeWon}}
                                                    </span>
                                                    <span
                                                        *ngIf="contest.totalCoinPrizeWon != null || contest.totalCoinPrizeWon != undefined">
                                                        {{contest.totalCoinPrizeWon}}
                                                    </span>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="rin-type-label state-finished">
                                                    <span class="prize-pool-heading"
                                                    *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                    {{contest.updatedPoolCoins}}
                                                    TPL Coins
                                                </span>
                                                <span class="prize-pool-heading"
                                                    style="white-space: nowrap;"
                                                    *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">
                                                    {{contest.updatedPoolCash}}
                                                    TPL Cash
                                                </span>
                                                    </span></td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="7">
                                                    <div class="not-found-section">
                                                        <div class="col-md-12 not-found-body">
                                                            <img src="assets/img/logo/not-found.gif" alt="">
                                                            <h4>Sorry! No Contest Found </h4>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary">
                                            <div
                                                class="p-d-flex p-ai-center p-jc-between">
                                                In total there are
                                                {{totalRecords }} Contest.
                                            </div>
                                        </ng-template>
                                    </p-table>
                                </div>
                                <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
                            </div>
                </div>
            </div>
        </main>
    </div>
</section>










<!-- ======= Product Section ======= -->





<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<div class="modal fade" id="mobile-filter-popup" tabindex="-1" aria-labelledby="mobile-filter-popupLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <div class="col-md-12 main-title">
                    <h4> <span><i class='bx bx-filter-alt'></i></span> Filters</h4>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body mobilefilter">
                <div class="col-md-3 p-0">
                    <div class="card date-filter-div">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-2">
                                <label for="startdt">Start Date</label>
                                <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                    [(ngModel)]="fstartDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                                    [showIcon]="true"></p-calendar>
                            </div>
                            <div class="p-field p-col-2">
                                <label for="enddt">End Date</label>
                                <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                    [(ngModel)]="fendDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                                    [showIcon]="true"></p-calendar>
                            </div>
                            <div class="p-field p-col" style="padding-top: 30px;">
                                <div class="button-div">
                                    <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-2"
                                        (click)="loadContest($event,mode)"></button>
                                </div>
                            </div>
                            <!-- <div class="p-field p-col-2" style="padding-top: 30px;">
                                <div class="clear-button-div">
                                    <button pButton label="Clear Filters"
                                        class="p-button-outlined p-mr-0 p-mb-0" icon="pi pi-filter-slash"
                                        pTooltip="Clear Filters" tooltipPosition="bottom"
                                        (click)="clear()"></button>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-md-12  p-p-0 left-side-bar-filter " style="display: block!important;">
                    <div class="left-side-section" style="box-shadow: none!important;"></div>
                </div>
            </div>
            <div class="modal-footer filter-button">

                <button pButton label="Clear Filters" class="p-button-outlined p-mr-0 p-mb-0" pTooltip="Clear Filters"
                    tooltipPosition="bottom" (click)="clear()"></button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close"
                    (click)="loadContest($event,mode)">Apply</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="mobile-filter-popup2" tabindex="-1" aria-labelledby="mobile-filter-popupLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <div class="col-md-12 main-title">
                    <h4> <span><i class='bx bx-filter-alt'></i></span> Filters</h4>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body mobilefilter">
                <div class="col-md-3 p-0">
                    <div class="card date-filter-div">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-2">
                                <label for="startdt">Start Date</label>
                                <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                    [(ngModel)]="fstartDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                                    [showIcon]="true"></p-calendar>
                            </div>
                            <div class="p-field p-col-2">
                                <label for="enddt">End Date</label>
                                <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                    [(ngModel)]="fendDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                                    [showIcon]="true"></p-calendar>
                            </div>
                            <div class="p-field p-col" style="padding-top: 30px;">
                                <div class="button-div">
                                    <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-2"
                                        (click)="loadContest($event,mode)"></button>
                                </div>
                            </div>
                            <!-- <div class="p-field p-col-2" style="padding-top: 30px;">
                                <div class="clear-button-div">
                                    <button pButton label="Clear Filters"
                                        class="p-button-outlined p-mr-0 p-mb-0" icon="pi pi-filter-slash"
                                        pTooltip="Clear Filters" tooltipPosition="bottom"
                                        (click)="clear()"></button>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-md-12  p-p-0 left-side-bar-filter " style="display: block!important;">
                    <div class="left-side-section" style="box-shadow: none!important;"></div>
                </div>
            </div>
            <div class="modal-footer filter-button">

                <button pButton label="Clear Filters" class="p-button-outlined p-mr-0 p-mb-0" pTooltip="Clear Filters"
                    tooltipPosition="bottom" (click)="clear()"></button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close"
                    (click)="loadContest($event,mode)">Apply</button>
            </div>
        </div>
    </div>
</div>